import React from 'react';
import SignIn from '../sign-in/sign-in.component';



const TestLoginComponent = () => (
    <div className='test-login' >
    <SignIn/>

    </div>
)
export default TestLoginComponent;